import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers';
import type { NormalizedAnnotator, Selector } from 'types';

const getAnnotators: Selector<NormalizedAnnotator[]> = createSelector(
  [(state: GlobalState): GlobalState['annotator']['items'] => state.annotator.items],
  (annotators) => Object.values(annotators)
);

export default getAnnotators;
